import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

/**
 * @param {boolean, number} userId - user ID
 */
const requestGetContentCreator = (userId) => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.GET,
    path: `/api/v1/users/find_user_by_id`,
    queryParams: [
      {
        name: 'id',
        value: userId,
      },
    ],
  });
};

export default requestGetContentCreator;
